import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  onSubmit(event) {
    if (event.detail.success) {
      const input = this.element.querySelector("input[name='post_comment[body]']")
      if (input) input.value = ""
      this.element.closest(".modal-comment__reply-form").style.display = "none"
    }
  }
}
